import { Injectable, NgZone } from '@angular/core';
import posthog from 'posthog-js';

@Injectable({
  providedIn: 'root'
})
export class PosthogService {
  constructor(private ngZone: NgZone) {}

  init(key: string, host: string) {
    this.ngZone.runOutsideAngular(() => {
      posthog.init(key, {
        api_host: host,
        ui_host: "https://eu.posthog.com",
        autocapture: true,
        capture_pageview: true,
        capture_pageleave: true
      });
    });
  }

  reset() {
    posthog.reset();
  }

  capture(event: string, properties?: Record<string, any>) {
    posthog.capture(event, properties);
  }

  identify(userId: string, properties?: Record<string, any>) {
    posthog.identify(userId, properties);
  }

  getDistinctId(): string {
    return posthog.get_distinct_id();
  }
}
